import { useEffect, useState } from "react";

import { useParams, useRouter, useSearch } from "@tanstack/react-router";
import { useRef } from "react";
import useIsMobile from "@/lib/utils/useIsMobile";
import { Button } from "@heroui/react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ntimeLogo from "@/assets/images/H-NTime-R.png";
import queryString from "query-string";
import { datadogRum } from "@datadog/browser-rum";
import useAuth from "../auth/useAuth";
function AngularApp() {
    const { runStartup } = useAuth();
    const { isMobile } = useIsMobile();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const router = useRouter();
    const params = useParams({
        from: "/ntimev1/$",
    });
    const search = useSearch({
        from: "/ntimev1/$",
    });

    const [angularRoute] = useState<string | undefined>(
        params._splat
            ? `${params._splat?.replace("angular/frontend", "")}?${queryString.stringify(search)}`
            : "",
    );

    useEffect(() => {
        const iframe = iframeRef.current;

        if (iframe) {
            const handleMessage = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) return;

                if (event.data.type === "new-ntime") {
                    localStorage.setItem("oldNTime", "false");
                    datadogRum.setUserProperty("oldNtime", "false");
                    runStartup();
                    router.navigate({
                        to: event.data.payload,
                    });
                }

                if (event.data.type !== "navigate") return;

                const { payload } = event.data;

                if (payload.startsWith("/index.html#")) {
                    return;
                }

                // We can whitelist routes out of using old N-Time here
                if (payload.startsWith("/dashboard/enrollment")) {
                    router.navigate({
                        to: payload,
                        replace: true,
                    });
                    return;
                }
                if (
                    payload != "/" &&
                    localStorage.getItem("oldNTime") !== "true" &&
                    location.pathname.replace("/ntimev1", "") != payload
                ) {
                    router.navigate({ to: payload });
                    return;
                }

                if (
                    payload != "/" &&
                    localStorage.getItem("oldNTime") === "true" &&
                    location.pathname.replace("/ntimev1", "") != payload
                ) {
                    history.replaceState(null, "", `/ntimev1${payload}`);
                    return;
                }
            };

            window.addEventListener("message", handleMessage);

            return () => {
                window.removeEventListener("message", handleMessage);
            };
        }
    }, [router, runStartup]);

    // useEffect(() => {
    //     if (localStorage.getItem("oldNTime") === "false") {
    //         router.navigate({
    //             to: params._splat,
    //             from: "/",
    //         });
    //     }
    // }, [router, params._splat]);

    return isMobile ? (
        <div className="w-screen h-screen left-0 top-0 absolute">
            <div className="w-full h-full flex flex-col items-center justify-center p-4 gap-2">
                <img src={ntimeLogo} className="w-1/2" />
                <h1>
                    This page isn't optimized for mobile just yet. For the best
                    experience, please view it on a desktop or tablet.
                </h1>
                <Button
                    color="primary"
                    variant="flat"
                    onPress={() => {
                        router.history.back();
                    }}
                    className="m-4"
                    startContent={<FontAwesomeIcon icon={faArrowLeft} />}
                >
                    Back to Previous Page
                </Button>
            </div>
        </div>
    ) : (
        <iframe
            ref={iframeRef}
            id="angular-iframe"
            src={`/angular/frontend/index.html#${angularRoute}`}
            className="w-screen h-screen left-0 top-0 absolute"
            title="Angular Application"
        />
    );
}

export default AngularApp;
